import api from "@beeldit/core/helpers/api";

async function remove(endpoint: string, id: number) {
  return api.delete(`/${endpoint}/${id}`);
}

export default remove;
